import React, { useState, useEffect } from 'react';
import { homeworkService } from '../../lib/services/homework';
import CalendarView from './CalendarView';
import HomeworkListView from './HomeworkListView';

const HomeworkCalendar = ({ selectedItem, selectedDate, onBack }) => {
  const [currentView, setCurrentView] = useState('calendar'); // 'calendar', 'list'
  const [homeworkAssignments, setHomeworkAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadHomeworkData = React.useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      // Get homework for the current month
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      
      const startDate = startOfMonth.toISOString().split('T')[0];
      const endDate = endOfMonth.toISOString().split('T')[0];

      const homework = await homeworkService.getHomeworkByDateRange(
        selectedItem.id || selectedItem.class_id,
        startDate,
        endDate
      );

      setHomeworkAssignments(homework);
    } catch (err) {
      console.error('Error loading homework data:', err);
      setError('載入家課資料時發生錯誤');
    } finally {
      setLoading(false);
    }
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem) {
      loadHomeworkData();
    }
  }, [selectedItem, loadHomeworkData]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayNames = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const dayName = dayNames[date.getDay()];
    
    return `${year}年${month}月${day}日 (${dayName})`;
  };

  if (loading) {
    return (
      <div className="homework-calendar">
        <div className="homework-calendar-header">
          <button className="back-btn" onClick={onBack}>
            ← 返回時間表
          </button>
          <h2>家課管理 - {formatDate(selectedDate)}</h2>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>載入家課資料中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="homework-calendar">
        <div className="homework-calendar-header">
          <button className="back-btn" onClick={onBack}>
            ← 返回時間表
          </button>
          <h2>家課管理 - {formatDate(selectedDate)}</h2>
        </div>
        <div className="error-container">
          <p>❌ {error}</p>
          <button onClick={loadHomeworkData} className="retry-btn">
            重新載入
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="homework-calendar">
      <div className="homework-calendar-header">
        <button className="back-btn" onClick={onBack}>
          ← 返回時間表
        </button>
        <h2>家課管理 - {formatDate(selectedDate)}</h2>
        <div className="date-selector">
          <input 
            type="date" 
            value={selectedDate}
            onChange={(e) => {
              // This would need to be handled by parent component
              // For now, we'll just show the current date
            }}
            className="date-input"
          />
        </div>
      </div>

      <div className="homework-calendar-nav">
        <button 
          className={`nav-tab ${currentView === 'calendar' ? 'active' : ''}`}
          onClick={() => setCurrentView('calendar')}
        >
          📅 日曆視圖
        </button>
        <button 
          className={`nav-tab ${currentView === 'list' ? 'active' : ''}`}
          onClick={() => setCurrentView('list')}
        >
          📝 清單視圖
        </button>
      </div>

      <div className="homework-calendar-content">
        {currentView === 'calendar' && (
          <CalendarView 
            homeworkAssignments={homeworkAssignments}
            selectedDate={selectedDate}
            onDateSelect={(date) => {
              // This would need to be handled by parent component
              console.log('Date selected:', date);
            }}
          />
        )}

        {currentView === 'list' && (
          <HomeworkListView 
            homeworkAssignments={homeworkAssignments}
            selectedDate={selectedDate}
          />
        )}
      </div>
    </div>
  );
};

export default HomeworkCalendar;
